import React from "react";

import Loader from "../../../../../components/Loader";
import MuiTable from "./MuiTable";
import { Box } from "@mui/material";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { columns } from "./boardManagementColumns";
import { useBoardManagementTable } from "../../hooks/useBoardManagementTable";

function Table() {
  const isMobile = useResponsive("down", "md");
  const { isLoading, isError, rows } = useBoardManagementTable();

  return (
    <>
      {isLoading && (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && isError && (
        <div className="loader-center">
          <p>Error</p>
        </div>
      )}
      {!isLoading && !isError && (
        <Box className={"board-table"} p={isMobile && 1} mt={isMobile && 1}>
          <MuiTable
            initialRows={rows || []}
            columns={columns(isMobile)}
            defaultSort={"board_name"}
            headerBgColor={"#F2F4F6"}
            scrollHeight={"calc(96vh - 120px)"}
          />
        </Box>
      )}
    </>
  );
}

export default React.memo(Table);
